import { MatchesV2Schema } from '@/views/sports/Matches/styles/MatchesV2.styles';

export const matchesV2Styles: MatchesV2Schema = {
  pageHeaderText: {
    color: 'beta.300',
    fontSize: 'lg',
    fontFamily: 'heading',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    mb: '3',
    p: ['3', null, '0'],
  },
  mainBoxWrapper: {
    height: '100%',
    overflow: 'hidden',
  },
  navOverride: {
    mb: '0',
  },
  divider: {
    display: 'none',
  },
};
